// Action Types
export const EMAIL_ACTIONS = {
	FETCH_REQUEST: "emails/FETCH_REQUEST",
	FETCH_SUCCESS: "emails/FETCH_SUCCESS",
	FETCH_FAILURE: "emails/FETCH_FAILURE",

	ADD_REQUEST:   "emails/ADD_REQUEST",
	ADD_SUCCESS:   "emails/ADD_SUCCESS",
	ADD_FAILURE:   "emails/ADD_FAILURE",

	UPDATE_REQUEST: "emails/UPDATE_REQUEST",
	UPDATE_SUCCESS: "emails/UPDATE_SUCCESS",
	UPDATE_FAILURE: "emails/UPDATE_FAILURE",

	REMOVE_REQUEST: "emails/REMOVE_REQUEST",
	REMOVE_SUCCESS: "emails/REMOVE_SUCCESS",
	REMOVE_FAILURE: "emails/REMOVE_FAILURE",

	CLEAR_ERROR: "emails/CLEAR_ERROR",
};

/**
 * Shape from C# EmailsWrongRight:
 * {
 *   id:         number
 *   wrongEmail: string
 *   rightEmail: string
 *   date:       string (ISO 8601)
 * }
 */

export const fetchEmailsRequest = () => ({ type: EMAIL_ACTIONS.FETCH_REQUEST });
export const fetchEmailsSuccess = (emails) => ({ type: EMAIL_ACTIONS.FETCH_SUCCESS, payload: emails });
export const fetchEmailsFailure = (error)  => ({ type: EMAIL_ACTIONS.FETCH_FAILURE, payload: error });

export const addEmailRequest = () => ({ type: EMAIL_ACTIONS.ADD_REQUEST });
export const addEmailSuccess = (email) => ({ type: EMAIL_ACTIONS.ADD_SUCCESS, payload: email });
export const addEmailFailure = (error)  => ({ type: EMAIL_ACTIONS.ADD_FAILURE, payload: error });

export const updateEmailRequest = () => ({ type: EMAIL_ACTIONS.UPDATE_REQUEST });
export const updateEmailSuccess = (email) => ({ type: EMAIL_ACTIONS.UPDATE_SUCCESS, payload: email });
export const updateEmailFailure = (error)  => ({ type: EMAIL_ACTIONS.UPDATE_FAILURE, payload: error });

export const removeEmailRequest = () => ({ type: EMAIL_ACTIONS.REMOVE_REQUEST });
export const removeEmailSuccess = (id)    => ({ type: EMAIL_ACTIONS.REMOVE_SUCCESS, payload: id });
export const removeEmailFailure = (error) => ({ type: EMAIL_ACTIONS.REMOVE_FAILURE, payload: error });

export const clearError = () => ({ type: EMAIL_ACTIONS.CLEAR_ERROR });
